export const MS = 1
export const SECOND_MS = 1000 * MS
export const MINUTE_MS = 60 * SECOND_MS
export const HOUR_MS = 60 * MINUTE_MS
export const DAY_MS = 24 * HOUR_MS

export const IMMEDIATE = 0
export const THIRTY_SECONDS = 30 * SECOND_MS
export const ONE_MINUTE = 1 * MINUTE_MS
export const THREE_MINUTES = 3 * MINUTE_MS
export const FIVE_MINUTES = 5 * MINUTE_MS
export const TEN_MINUTES = 10 * MINUTE_MS
export const FIFTEEN_MINUTES = 15 * MINUTE_MS
export const THIRTY_MINUTES = 30 * MINUTE_MS
export const ONE_HOUR = 1 * HOUR_MS
